import { apiGet, apiSend } from './api.js';
import type {
  Release,
  RolloutCampaign,
  CampaignInstallation,
  CreateReleaseRequest,
  CreateCampaignRequest,
} from '@hospasense/contracts';

export async function fetchReleases(): Promise<Release[]> {
  const data = await apiGet<{ items: Release[] }>('/api/v1/releases');
  return data.items;
}

export async function fetchRelease(id: string): Promise<Release> {
  return apiGet<Release>(`/api/v1/releases/${id}`);
}

export async function createRelease(input: CreateReleaseRequest): Promise<Release> {
  return apiSend<Release>('POST', '/api/v1/releases', input);
}

export async function publishRelease(id: string): Promise<Release> {
  return apiSend<Release>('POST', `/api/v1/releases/${id}/publish`);
}

export async function fetchRolloutCampaigns(): Promise<RolloutCampaign[]> {
  const data = await apiGet<{ items: RolloutCampaign[] }>('/api/v1/releases/campaigns');
  return data.items;
}

export async function fetchCampaign(
  id: string,
): Promise<{ campaign: RolloutCampaign; installations: CampaignInstallation[] }> {
  return apiGet<{ campaign: RolloutCampaign; installations: CampaignInstallation[] }>(
    `/api/v1/releases/campaigns/${id}`,
  );
}

export async function createCampaign(input: CreateCampaignRequest): Promise<RolloutCampaign> {
  return apiSend<RolloutCampaign>('POST', '/api/v1/releases/campaigns', input);
}

export async function startCampaign(id: string): Promise<RolloutCampaign> {
  return apiSend<RolloutCampaign>('POST', `/api/v1/releases/campaigns/${id}/start`);
}

export async function pauseCampaign(id: string, reason: string): Promise<RolloutCampaign> {
  return apiSend<RolloutCampaign>('POST', `/api/v1/releases/campaigns/${id}/pause`, { reason });
}

export async function resumeCampaign(id: string): Promise<RolloutCampaign> {
  return apiSend<RolloutCampaign>('POST', `/api/v1/releases/campaigns/${id}/resume`);
}

export async function rollbackCampaign(id: string, reason: string): Promise<RolloutCampaign> {
  return apiSend<RolloutCampaign>('POST', `/api/v1/releases/campaigns/${id}/rollback`, { reason });
}
